import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_PIEZAS = {
  seachPiezas: async (search) => {
    return await API.get('/piezas?search=' + search).then(res => res.data);
  },
  getPiezasIntegraciones: async (search, page = null) => {
    const pagination = page !== null ? '&page=' + page : '';
    let query = Object.keys(search).filter((key) => search[key] !== null && search[key] !== "" && search[key] !== 0 && search[key] !== "0")
      .map((key, i) => { return i === 0 ? '?' + key + '=' + search[key] : '&' + key + '=' + search[key]; })
    query = query.join("");

    return await API.get(`/integracion/stock` + query + pagination).then((res)=> {
      return res.data
    });
  },
  newPieza: async (pieza) => {
    return API.post('/piezas/', pieza, pieza instanceof FormData ? headers : null).then(res => res.data);
  },
  updatePieza: async (pieza) => {
    return API.post('/piezas/' + pieza.id, pieza, pieza instanceof FormData ? headers : null).then(res => res.data);
  },
  updatePiezaPagoProveedor: async (piezaId, pieza) => {
    return API.put('/piezas/' + piezaId + '/pago-proveedor', pieza).then(res => res.data);
  },
  deletePieza: async (idPieza) => {
    return API.delete('/piezas/' + idPieza).then(res => res.data);
  }
}